import { apiClient } from '@/lib/apiClient';
import type { ActivityLog, ApiResponse } from "dico-types";

export interface ListActivityLogsParams {
  limit?: number;
  offset?: number;
}

/**
 * List activity logs for a workspace
 */
export async function listWorkspaceActivityLogs(
  workspaceId: string,
  params?: ListActivityLogsParams
): Promise<ActivityLog[]> {
  const queryParams = new URLSearchParams();
  if (params?.limit) queryParams.set('limit', params.limit.toString());
  if (params?.offset) queryParams.set('offset', params.offset.toString());

  const url = `/api/workspaces/${workspaceId}/activity-logs${
    queryParams.toString() ? `?${queryParams.toString()}` : ''
  }`;

  const response = await apiClient.get<ApiResponse<ActivityLog[]>>(url);
  return response.data;
}

/**
 * List activity logs for a specific integration
 */
export async function listIntegrationActivityLogs(
  workspaceId: string,
  integrationId: string,
  params?: ListActivityLogsParams
): Promise<ActivityLog[]> {
  const queryParams = new URLSearchParams();
  if (params?.limit) queryParams.set('limit', params.limit.toString());
  if (params?.offset) queryParams.set('offset', params.offset.toString());

  const url = `/api/workspaces/${workspaceId}/integrations/${integrationId}/activity-logs${
    queryParams.toString() ? `?${queryParams.toString()}` : ''
  }`;

  const response = await apiClient.get<ApiResponse<ActivityLog[]>>(url);
  return response.data;
}

/**
 * List activity logs for a specific ticket
 */
export async function listTicketActivityLogs(
  workspaceId: string,
  ticketId: string,
  params?: ListActivityLogsParams
): Promise<ActivityLog[]> {
  const queryParams = new URLSearchParams();
  if (params?.limit) queryParams.set('limit', params.limit.toString());
  if (params?.offset) queryParams.set('offset', params.offset.toString());

  const url = `/api/workspaces/${workspaceId}/tickets/${ticketId}/activity-logs${
    queryParams.toString() ? `?${queryParams.toString()}` : ''
  }`;

  const response = await apiClient.get<ApiResponse<ActivityLog[]>>(url);
  return response.data;
}
